const healthCondition = [
  { label: "Normal", value: "Normal" },
  { label: "Major Health Issues", value: "Major Health Issues" },
  { label: "Minor Health Issues", value: "Minor Health Issues" },
  { label: "Minor Physical Disability", value: "Minor Physical Disability" },
  { label: "Major Physical Disability", value: "Major Physical Disability" },
];
export default healthCondition;
